import React, { useEffect, useState } from "react";
import Text from "../../text";
import Box from "../../box/Box";
export default (function (_a) {
    var adjustedPrice = _a.adjustedPrice, freeShippingThreshold = _a.freeShippingThreshold;
    var _b = useState(false), isOpen = _b[0], setIsOpen = _b[1];
    useEffect(function () {
        var _a, _b;
        (_b = (_a = window.loyaltylion) === null || _a === void 0 ? void 0 : _a.ui) === null || _b === void 0 ? void 0 : _b.refresh();
    }, [adjustedPrice]);
    return (React.createElement(Box, { bg: "grays.0", p: 5, mt: 4, mb: 6, display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" },
        freeShippingThreshold !== null && (React.createElement(React.Fragment, null,
            React.createElement(Text, { as: "button", mb: 2, fontSize: 0, textTransform: "uppercase", textDecoration: "underline", onClick: function () { return setIsOpen(function (isOpen) { return !isOpen; }); } },
                "Free Shipping Over $",
                freeShippingThreshold,
                React.createElement("sup", null, "*")),
            isOpen && (React.createElement(Text, { mb: 4, fontSize: 0, textAlign: "center", maxWidth: "240px" },
                React.createElement("sup", null, "*"),
                "Free shipping is only available in the contiguous U.S. and excludes Fitness and Digital items.")))),
        React.createElement(Text, { fontSize: 0 },
            React.createElement("a", { href: "/onnit-x/", target: "_blank", style: { display: "inline", textDecoration: "underline" } },
                "ONNIT X REWARDS",
                " "),
            React.createElement(Text, { fontSize: 0, display: "inline" },
                ": Earn ",
                React.createElement("span", { "data-lion-points-for": adjustedPrice * 100 }),
                " points"))));
});
//# sourceMappingURL=BuyBoxFooter.js.map